import {Center} from '~/components/Center';
import {Specs} from './Specs';
import {Header} from './Header';
import {Title} from '~/components/Title';
import {LoaderArgs} from '@shopify/remix-oxygen';
import {useTranslation} from 'react-i18next';
import {ProductsSlider} from '../../components/ProductsSlider';
import {ProductPageData} from '../../services/GetProductPageService';

interface ProductPageProps {
  data: ProductPageData;
}

export function ProductPage({data}: ProductPageProps) {
  const product = data.page.product;
  const relatedProducts = data.page.relatedProducts;

  const {t} = useTranslation();

  return (
    <div className="w-full">
      <Center className="pb-20 lg:px-20 lg:pt-10">
        <Header product={product} />

        <section className="px-5 mb-10 md:px-10">
          <Title i18nKey="descripcion" level="h2" className="mb-6 text-2xl" />

          <div
            className="font-medium text-gray-500"
            dangerouslySetInnerHTML={{
              __html: product.descriptionHtml,
            }}
          />
        </section>

        <section>
          <div className="px-5 mb-6 md:px-10">
            <Title i18nKey="ficha-tecnica" level="h2" className="text-2xl" />
          </div>

          <Specs specs={product.specs} />
        </section>
      </Center>

      {relatedProducts.length ? (
        <section className="py-20 bg-gray-100">
          <Center as="section" className="px-5 mb-16 md:px-10 lg:px-30">
            <h1 className="text-3xl font-bold uppercase sm:text-4xl">
              {t('mas-productos')}
            </h1>
          </Center>

          <ProductsSlider items={relatedProducts} />
        </section>
      ) : null}
    </div>
  );
}

export async function loader({context, params}: LoaderArgs) {
  const data = await context.getProductPageService.get(params.handle as string);

  if (!data) {
    throw new Response('Not found', {
      status: 404,
    });
  }

  return data;
}
